console.log("🚀 form-prefill.js wurde geladen");

document.addEventListener("DOMContentLoaded", function () {
  const product = new URLSearchParams(window.location.search).get("product");
  if (!product) {
    console.warn("❌ Kein 'product' in der URL");
    return;
  }

  const observer = new MutationObserver(() => {
    const formEmbed = document.querySelector("form-embed");
    if (!formEmbed || !formEmbed.shadowRoot) return;

    const input = formEmbed.shadowRoot.querySelector('#custom\\#produkt');
    if (!input) {
      console.warn("❌ Produktfeld im Shadow DOM nicht gefunden");
      return;
    }

    setTimeout(() => {
      input.value = decodeURIComponent(product);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      console.log("✅ Produktfeld befüllt mit:", input.value);
      observer.disconnect();
    }, 500);
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
